import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../../utils/hooks/useAxios";

export const useGetServiceCentersNuskQuery = (params = {}) => {
  const { axiosProtected } = useAxios();

  return useQuery({
    queryKey: ["service-centers-nusk", params],
    queryFn: () =>
      axiosProtected.get("service-centers/nusk", { params }),
  });
};
